export enum types {
  LOGIN_ATTEMPT,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
}


// WEBPACK FOOTER //
// ./src/reducers/user/types.ts